import { fabric } from 'fabric';
import { Group, Object } from 'fabric/fabric-impl';
import getGroupObjects from 'ud-ui/components/fabric-canvas/addons/replacer/utils/get-group-objects';
import Static from '../../canvases/static';
import FadeIn from '../fadeIn';

export class CanvasUtils {
  private manager: Static;
  private fade: FadeIn;

  constructor(manager: Static) {
    this.manager = manager;
    this.fade = new FadeIn();
    this.fade.init(manager);
  }

  setOpacity(obj: fabric.Object[], opacity: number) {
    for (const o of obj) {
      o.set({ opacity: opacity });
    }
  }

  setOpacityAllObjs(opacity: number) {
    const objects = this.manager.canvas.getObjects();
    this.setOpacity(objects, opacity);
  }

  ungroupObjects() {
    const canvas = this.manager.canvas;
    const allObjects = canvas.getObjects();
    allObjects.reduce((previousValue: Object[], object) => {
      if (object.data?.type === 'group') {
        const group = object as Group;
        canvas.remove(group);
        const children = getGroupObjects(group);
        canvas.add(...children);
        return [...previousValue, ...children];
      } else {
        return [...previousValue, object];
      }
    }, []);
  }
}
